// HashtagCategoryItem.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { LinkWithLanguage as Link } from '../component/LinkWithLanguage.jsx';
import { searchType } from '../resource/searchConstants.js';
import { ButtonId } from '../resource/mixpanel.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

import media from '../style/media.js';

const { FEED, SEARCH } = TranslationNamespace;

export const HashtagCategoryItem = ({
  item = '',
  index = 0,
  type = searchType.FLIX,
  feedId = '',
  isMessageCategory = false,
  i18n,
  setRecentSearchHashtag = () => null,
  t,
}) => {
  let toUrl;
  let displayText;
  let buttonId;
  const trackingPayload = {
    'discover.index': index + 1,
    'discover.category': feedId,
    [isMessageCategory ? 'category.content' : 'hashtag.content']: item,
  };

  if (isMessageCategory) {
    const i18nKey = `category_${item}`;
    const isTranslationExisted = i18n.exists(i18nKey, { ns: FEED });
    toUrl = `/category/${item}`;
    displayText = isTranslationExisted ? t(i18nKey, { ns: FEED }) : item;
    buttonId = `category-${item}`;
  } else {
    const i18nKey = `hashtag_${item}`;
    const isTranslationExisted = i18n.exists(i18nKey, { ns: SEARCH });
    toUrl = `/hashtag/${item}/${type}`;
    displayText =
      '#' + (isTranslationExisted ? t(i18nKey, { ns: SEARCH }) : item);
    buttonId = ButtonId.Home.ButtonTrendingHashtag;
  }

  return (
    <StyledHashtagCategoryItem
      to={toUrl}
      data-element_id={buttonId}
      data-tracking_payload={trackingPayload}
      onClick={() => {
        if (!isMessageCategory) {
          setRecentSearchHashtag({ query: item });
        }
      }}
    >
      {displayText}
    </StyledHashtagCategoryItem>
  );
};

HashtagCategoryItem.propTypes = {
  item: PropTypes.string,
  index: PropTypes.number,
  type: PropTypes.string,
  feedId: PropTypes.string,
  isMessageCategory: PropTypes.bool,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  setRecentSearchHashtag: PropTypes.func,
};

const StyledHashtagCategoryItem = styled(Link)`
  margin-right: 8px;
  border-radius: 30px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 18px;
  cursor: pointer;
  white-space: nowrap;
  background-color: rgba(255, 255, 255, 0.1);
  list-style: none;
  :last-child {
    margin-right: 0px;
  }
  ${media.tablet`
    margin-right: 4px;
    padding: 0px 12px;
    height: 28px;
    font-size: 14px;
  `};
`;

export default withTranslation()(HashtagCategoryItem);
